import { setAuthToken } from "@/utils/token";
import { useAtom } from "jotai";
import { userAtom } from "@/store";

export const useLoginResult = () => {
  const [, setUser] = useAtom(userAtom);

  const loginSuccess = (token: string) => {
    setAuthToken(token as string);
    setUser({ name: '', accessToken: token as string });
  };

  const logoutClear = () => {
    localStorage.removeItem('accessToken');
    setUser({ name: '', accessToken: null });
  };
  return {
    loginSuccess,
    logoutClear,
  };
};